/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.referrals.init());

App.referrals = {
  init() {
    return null;
  },

  // After the form is submitted
  submitted(json) {
    if (json.bad_addresses.length === 0) {
       App.modals.close_all();
       return location.reload();
    } else {
      $(".js-referral-addresses").val(json.bad_addresses);
      return new App.FormErrors(json);
    }
  }
};
      